import { FormControl, FormGroup } from '@angular/forms';
import {
    BookingSummaryDto,
    CreateShippingInstructionDto,
} from '@opb-workspace/shared';
export type Step2RestoreResult =
    | { mode: 'booking'; shipperName?: string }
    | { mode: 'external-booking' }
    | { mode: 'parties' }
    | { mode: 'none' };

export function restoreStep2FormFromWizardSnapshot(
    form: FormGroup,
    bookingInputCtrl: FormControl<string | BookingSummaryDto>,
    formData: Partial<CreateShippingInstructionDto>,
    availableBookings: BookingSummaryDto[],
): Step2RestoreResult {
    form.patchValue(
        {
            bookingNumber: formData.bookingNumber ?? '',
            customerContactEmail: formData.customerContactEmail ?? '',
            customerAttentionContactName:
                formData.customerAttentionContactName ?? '',
            customerTaxIdentificationNumber:
                formData.customerTaxIdentificationNumber ?? '',
            shipperEmail: formData.shipperEmail ?? '',
            shipperTaxIdentificationNumber:
                formData.shipperTaxIdentificationNumber ?? '',
            shipperContactName: formData.shipperContactName ?? '',
            shipperPhoneNumber: formData.shipperPhoneNumber ?? '',
            shipperMobilePhoneNumber: formData.shipperMobilePhoneNumber ?? '',
            consigneeEmail: formData.consigneeEmail ?? '',
            consigneeTaxIdentificationNumber:
                formData.consigneeTaxIdentificationNumber ?? '',
            consigneeContactName: formData.consigneeContactName ?? '',
            consigneePhoneNumber: formData.consigneePhoneNumber ?? '',
            consigneeMobilePhoneNumber:
                formData.consigneeMobilePhoneNumber ?? '',
            notifyEmail: formData.notifyEmail ?? '',
            notifyTaxIdentificationNumber:
                formData.notifyTaxIdentificationNumber ?? '',
            notifyContactName: formData.notifyContactName ?? '',
            notifyPhoneNumber: formData.notifyPhoneNumber ?? '',
            notifyMobilePhoneNumber: formData.notifyMobilePhoneNumber ?? '',
        },
        { emitEvent: false },
    );
    if (formData.bookingId) {
        form.patchValue({ selectedBookingId: formData.bookingId });
        const sel = availableBookings.find(
            (b) => b.bookingId === formData.bookingId,
        );
        if (sel) {
            bookingInputCtrl.setValue(sel, { emitEvent: false });
        }
        if (formData.shipperPartyId) {
            form.patchValue(
                {
                    shipperPartyId: formData.shipperPartyId,
                    shipperName: formData.shipperName ?? '',
                    shipperAddress: formData.shipperAddress ?? '',
                    shipperEmail: formData.shipperEmail ?? '',
                    shipperTaxIdentificationNumber:
                        formData.shipperTaxIdentificationNumber ?? '',
                    shipperContactName: formData.shipperContactName ?? '',
                    shipperPhoneNumber: formData.shipperPhoneNumber ?? '',
                    shipperMobilePhoneNumber:
                        formData.shipperMobilePhoneNumber ?? '',
                },
                { emitEvent: false },
            );
        }
        if (formData.consigneePartyId) {
            form.patchValue(
                {
                    consigneePartyId: formData.consigneePartyId,
                    consigneeName: formData.consigneeName ?? '',
                    consigneeAddress: formData.consigneeAddress ?? '',
                    consigneeEmail: formData.consigneeEmail ?? '',
                    consigneeTaxIdentificationNumber:
                        formData.consigneeTaxIdentificationNumber ?? '',
                    consigneeContactName: formData.consigneeContactName ?? '',
                    consigneePhoneNumber: formData.consigneePhoneNumber ?? '',
                    consigneeMobilePhoneNumber:
                        formData.consigneeMobilePhoneNumber ?? '',
                },
                { emitEvent: false },
            );
        }
        if (formData.notifyPartyId) {
            form.patchValue(
                {
                    notifyPartyId: formData.notifyPartyId,
                    notifyName: formData.notifyName ?? '',
                    notifyAddress: formData.notifyAddress ?? '',
                    notifyEmail: formData.notifyEmail ?? '',
                    notifyTaxIdentificationNumber:
                        formData.notifyTaxIdentificationNumber ?? '',
                    notifyContactName: formData.notifyContactName ?? '',
                    notifyPhoneNumber: formData.notifyPhoneNumber ?? '',
                    notifyMobilePhoneNumber:
                        formData.notifyMobilePhoneNumber ?? '',
                },
                { emitEvent: false },
            );
        }
        return { mode: 'booking', shipperName: sel?.shipperName };
    }
    if (formData.shipperPartyId) {
        form.patchValue({
            shipperPartyId: formData.shipperPartyId,
            shipperName: formData.shipperName,
            shipperAddress: formData.shipperAddress,
            shipperEmail: formData.shipperEmail ?? '',
            shipperTaxIdentificationNumber:
                formData.shipperTaxIdentificationNumber ?? '',
            shipperContactName: formData.shipperContactName ?? '',
            shipperPhoneNumber: formData.shipperPhoneNumber ?? '',
            shipperMobilePhoneNumber: formData.shipperMobilePhoneNumber ?? '',
            consigneePartyId: formData.consigneePartyId,
            consigneeName: formData.consigneeName,
            consigneeAddress: formData.consigneeAddress,
            consigneeEmail: formData.consigneeEmail ?? '',
            consigneeTaxIdentificationNumber:
                formData.consigneeTaxIdentificationNumber ?? '',
            consigneeContactName: formData.consigneeContactName ?? '',
            consigneePhoneNumber: formData.consigneePhoneNumber ?? '',
            consigneeMobilePhoneNumber:
                formData.consigneeMobilePhoneNumber ?? '',
            notifyPartyId: formData.notifyPartyId,
            notifyName: formData.notifyName,
            notifyAddress: formData.notifyAddress,
            notifyEmail: formData.notifyEmail ?? '',
            notifyTaxIdentificationNumber:
                formData.notifyTaxIdentificationNumber ?? '',
            notifyContactName: formData.notifyContactName ?? '',
            notifyPhoneNumber: formData.notifyPhoneNumber ?? '',
            notifyMobilePhoneNumber: formData.notifyMobilePhoneNumber ?? '',
            customerContactEmail: formData.customerContactEmail ?? '',
            customerAttentionContactName:
                formData.customerAttentionContactName ?? '',
            customerTaxIdentificationNumber:
                formData.customerTaxIdentificationNumber ?? '',
        });
        return { mode: 'parties' };
    }
    const externalBn = (formData.bookingNumber ?? '').trim();
    if (externalBn) {
        bookingInputCtrl.setValue(externalBn, { emitEvent: false });
        return { mode: 'external-booking' };
    }
    return { mode: 'none' };
}
